import { createSelector } from "reselect"
import { get, findIndex, forEach } from "lodash"
import { computeSort } from "helpers/securities-search"
import { getMissingDataFiles } from "selectors/missingDataFiles"
import { getIsOpPro } from "modules/account-root/selectors"

export const getSecuritiesCount = state => get(state, "global.data.foundSecurities.data.model.securitySearch.count")
export const getFoundSecurities = state => get(state, "global.data.foundSecurities.data.model.securitySearch.securities")
export const getSelectedSecurities = state => state.modules.securitiesFinderResults.selectedSecurities
export const getWatchlistsMenuVisible = state => get(state, "modules.securitiesFinderResults.watchlistsMenuVisible", false)
export const getModelCurrentDate = state => get(state, "global.data.dates.data.model.availability.currentDate")
export const getModelId = (_, props) => get(props, "modelId")
export const getErrorMessage = state => get(state, "global.data.foundSecurities.apiMessages.errors[0].message")
const getRawSort = (_, props) => props.selectedSort

export const getSort = createSelector(
  [getRawSort, getMissingDataFiles, getModelId, getIsOpPro],
  computeSort,
)

export const getToolbarActive = createSelector(
  [getSelectedSecurities],
  (selectedSecurities) =>
    selectedSecurities.total > 0,
)

export const getCurrentPageSelectionStatus = createSelector(
  [getSelectedSecurities, getFoundSecurities],
  (selectedSecurities, foundSecurities) => {
    if (selectedSecurities.total > 0 && foundSecurities) {
      let inPage = 0

      forEach(selectedSecurities.securities, (security, key) => {
        if (findIndex(foundSecurities, { id: key }) >= 0) {
          inPage += 1
        }
      })

      if (inPage === foundSecurities.length) {
        return "all"
      } else if (inPage > 0) {
        return "intermediate"
      }
    }

    return null
  },
)
